// src/com/file_of_report/StoreTransReportGql.js
import { gql } from "@apollo/client";

/*

extend type Mutation {
    storeTransReportAdd(storeTransReport: InputStoreTransReportAdd!): ResponseWithFileCreateHisItem!
}

input InputStoreTransReportAdd {
    dateFrom: String!
    dateTill: String!
}

*/


export const CREATE_STORE_TRANS_REPORT = gql`
mutation CreateStoreTransReport($storeTransReport:InputStoreTransReportAdd!) {
    storeTransReportAdd(storeTransReport: $storeTransReport) {
        ok
        message
        item {
            fileCreateHisSeq
        }
    }
}
`;
